module.exports = __webpack_public_path__ + "static/media/cp-logo.44ee1501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cp-logo.png
// module id = 404
// module chunks = 1